export const environment = {
  productionMode: true,
  baseApiUrl: 'https://api.dealers-stock.jp/v1',
  GMO_ShopID: '9200003773203',
  sentryDns: 'https://d1abf691806205fec480ee29f2d707df@o4508618675388416.ingest.us.sentry.io/4508619287691264',
};
